import { render, staticRenderFns } from "./NO_DATA.vue?vue&type=template&id=45ec98b0&scoped=true"
import script from "./NO_DATA.vue?vue&type=script&lang=js"
export * from "./NO_DATA.vue?vue&type=script&lang=js"
import style0 from "./NO_DATA.vue?vue&type=style&index=0&id=45ec98b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ec98b0",
  null
  
)

export default component.exports